import React from 'react';
import PropTypes from 'prop-types';
import AutoBatchingModal from './index';
import { OrderGridFilterPropType } from '../../../prop-types/order-grid-filter';
import { AutoBatchingContextProvider } from './context';
import { ModalFrameworkMethodsPropType } from 'ui-components/prop-types/modal-framework-methods';
import { emptyArray } from 'ui-components/default-props/empty';

const ContextWrappedAutoBatchingModal = ({ gridFilters, totalRecords, selectedFulfillmentPlanIds = emptyArray, modalFrameworkMethods }) => {
  const { closeModal } = modalFrameworkMethods;
  return (
    <AutoBatchingContextProvider
      gridFilters={gridFilters}
      selectedFulfillmentPlanIds={selectedFulfillmentPlanIds}
      totalRecords={totalRecords}
    >
      <AutoBatchingModal onCloseModal={closeModal} />
    </AutoBatchingContextProvider>
  );
};

ContextWrappedAutoBatchingModal.propTypes = {
  gridFilters: OrderGridFilterPropType,
  totalRecords: PropTypes.number.isRequired,
  selectedFulfillmentPlanIds: PropTypes.arrayOf(PropTypes.string),
  modalFrameworkMethods: ModalFrameworkMethodsPropType.isRequired,
};

export { ContextWrappedAutoBatchingModal };
